import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { Observable, switchMap } from 'rxjs';
import { RaffleResponse } from '../interfaces/raffle';
/**
 * The Servie to get Raffle Winers
 */
@Injectable({
  providedIn: 'root'
})
export class RaffleService {
  /**
   * constructor
   * @param http 
   * @param environment 
   */
  constructor(
    private http: HttpClient,
    private environment: EnvironmentService) {

  }
  /**
   * Get the Winners of the Raffle (size is the Count of the Winners)
   * @param publicID 
   * @param size 
   * @returns 
   */
  getWinnersForRaffle(publicID: string, size: string): Observable<RaffleResponse> {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.get<RaffleResponse>(`${url}/event/${publicID}/raffle/?size=${size}`)
      )
    )
  }
}
